import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateISOStringPipe } from './date-iso-string.pipe';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ DateISOStringPipe ],
    exports: [ DateISOStringPipe ],
})
export class DateISOStringPipeModule {}
